import { Pedido } from '../../types/pedido';
import { ETIQUETAS_ESTADO } from '../../types/pedido';
import { EstadoPedidoBadge } from '../shared/Badge';

interface Props {
  pedidos: Pedido[];
  onVerDetalle: (pedido: Pedido) => void;
}

function tiempoRelativo(fechaIso: string): string {
  const minutos = Math.round((Date.now() - new Date(fechaIso).getTime()) / 60000);
  if (minutos < 60) return `hace ${minutos} min`;
  const horas = Math.round(minutos / 60);
  if (horas < 24) return `hace ${horas} h`;
  return `hace ${Math.round(horas / 24)} d`;
}

export function OrderTable({ pedidos, onVerDetalle }: Props) {
  return (
    <div className="bg-white border border-admin-border rounded-xl overflow-x-auto">
      <table className="w-full min-w-[640px] border-collapse text-[13px]">
        <thead>
          <tr>
            {['Cliente', 'Teléfono', 'Total', 'Estado', 'Última actualización', ''].map((h) => (
              <th
                key={h}
                className="text-left text-[11px] font-bold uppercase tracking-wide text-admin-ink-muted px-4 py-2.5 border-b border-admin-border"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {pedidos.map((pedido) => {
            const ultimaEntrada = pedido.historialEstado[pedido.historialEstado.length - 1];
            return (
              <tr key={pedido.id} data-testid={`order-table-row-${pedido.id}`} className="border-b border-admin-border/60 last:border-0">
                <td className="px-4 py-3.5 font-semibold">{pedido.contacto.nombre}</td>
                <td className="px-4 py-3.5">{pedido.contacto.telefono}</td>
                <td className="px-4 py-3.5 font-bold">S/ {pedido.totalPedido.toFixed(2)}</td>
                <td className="px-4 py-3.5">
                  <EstadoPedidoBadge estado={pedido.estado} etiqueta={ETIQUETAS_ESTADO[pedido.estado]} />
                </td>
                <td className="px-4 py-3.5 text-admin-ink-muted">
                  {tiempoRelativo(pedido.fechaCreacion)}
                  {ultimaEntrada && ultimaEntrada.actorId !== 'cliente' ? ` · por ${ultimaEntrada.actorId}` : ''}
                </td>
                <td className="px-4 py-3.5 text-right">
                  <button
                    onClick={() => onVerDetalle(pedido)}
                    data-testid={`order-table-detail-${pedido.id}`}
                    className="text-terracotta font-bold text-xs"
                  >
                    Ver detalle
                  </button>
                </td>
              </tr>
            );
          })}
          {pedidos.length === 0 && (
            <tr>
              <td colSpan={6} className="px-4 py-8 text-center text-admin-ink-muted">
                No hay pedidos para mostrar.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
